import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const Form = styled.form`
  width: 100%;
  margin-top: 20px;
`;

const LinkImage = styled.a`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 30px !important;
  border: none;
  margin-top: 80px;
  outline-style: none;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

const Span = styled.span`
  margin-left: 10px;
`;

const InputFile = styled.input`
  display: none;
`;

export { Container, Form, LinkImage, Span, InputFile };
